export const getRviCardUrl = (productIdsArray) => {
  if (productIdsArray.length === 1) {
    const singleElementId = productIdsArray[0];
    return `/shop/product/?ID=${singleElementId}&RVI=Browse_1&tdp=cm_choiceId~z${singleElementId}~xcm_pos~zPos1`;
  }
  return `/shop/featured/${productIdsArray.join('%7C')}`;
};
